import { ApiEndPoint } from '@/domains/api/api.entity';
import type {
  CenterLayerApiRawResponse,
  CenterLayerApiResponse,
} from '@/domains/centerLayer/centerLayer.entity';
import type { Center } from '@/domains/shared';
import { apiRequest } from './apiRequest';
import { centerLayerApiMapper } from './mappers/centerLayerApi.mapper';

/**
 * Implementación de la lógica para llamar al API de centerLayer
 */
class CenterLayerApiService {
  /**
   * Obtención de datos completos de centerLayer desde el endpoint
   */
  async getCenterLayer(center: Center): Promise<CenterLayerApiResponse> {
    /**
     * GET para obtener datos completos de centerLayer
     * Recibe parámetro dinámico center (ej: 'li', 'pa', etc.)
     */
    const centerLayerResponse = await apiRequest.get<CenterLayerApiRawResponse>(
      {
        route: ApiEndPoint.LAYER_CENTER,
        param: `/${center}`,
      },
    );

    return centerLayerApiMapper.rawToEntity(centerLayerResponse);
  }
}

export const centerLayerApiService = new CenterLayerApiService();
